import { useTranslation } from 'react-i18next';
import { CalendarCounts } from 'src/domain/analytics';
import { AnalyticsCard } from './AnalyticsCard';
import { MetricCards } from './MetricCards';

export const CalendarSummary = ({ calendar }: { calendar: CalendarCounts }) => {
    const { t, i18n } = useTranslation();
    return (
        <AnalyticsCard
            info={t('admin.analytics.calendarNote')}
            title={t('admin.analytics.calendar')}
            description={t('admin.analytics.calendarShort')}
        >
            <MetricCards
                metrics={[
                    {
                        label: t('admin.analytics.eventsCreated'),
                        value: calendar.eventsCreated.toLocaleString(
                            i18n.language,
                        ),
                    },
                    {
                        label: t('admin.analytics.rsvpResponses'),
                        value: calendar.rsvpResponses.toLocaleString(
                            i18n.language,
                        ),
                    },
                ]}
            />
            {calendar.eventsByType && (
                <dl className="analytics-detail-list">
                    {Object.entries(calendar.eventsByType)
                        .filter(([type]) => type !== 'unknown')
                        .map(([type, count]) => (
                            <div key={type}>
                                <dt>
                                    {t(`admin.analytics.eventType_${type}`)}
                                </dt>
                                <dd>{count.toLocaleString(i18n.language)}</dd>
                            </div>
                        ))}
                </dl>
            )}
        </AnalyticsCard>
    );
};
